/* eslint-disable no-shadow */
import * as React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { useCallback, useEffect, useState } from 'react';
import InitialPage from '../../../pages/InitialPage';
import { MainContent } from '../../mainLayout/styles';
import { netzwerkBackground } from '../../../assets/netzwerkBackground';
import darkBackgroundImage from '../../../assets/Background-HomePage.png';
import { useTheme } from '../../../context/ThemeContext';
import api from '../../../services/api';
import { Widget } from '../../../pages/UserGroupsPage';

interface props {
  setOpen: any;
  handleClose: any;
  usergroup?: any;
}
const PreviewUserGroupContent: React.FC<props> = ({
  setOpen,
  handleClose,
  usergroup = undefined,
}) => {
  const [userGroupNameForm, setUserGroupNameForm] = useState<string>('');
  const [widgetsTree, setWidgetsTree] = useState<Widget>();
  const { isDarkMode } = useTheme();

  const handleCancel = useCallback((): void => {
    setUserGroupNameForm('');
    setOpen(false);
    handleClose();
  }, [handleClose, setOpen]);

  useEffect(() => {
    if (usergroup) setUserGroupNameForm(usergroup.name);

    api
      .get(`/widgets/tree/${usergroup.settings.widgets}`)
      .then((response: any) => {
        setWidgetsTree(response.data);
      })
      .catch((err: any) => {
        console.log(err);
      });
  }, [usergroup]);

  return (
    <>
      <Box
        style={{
          width: '1000px',
          height: '900px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <DialogTitle>{`User Group Preview: ${userGroupNameForm}`}</DialogTitle>
        <DialogContent>
          <MainContent
            id="main-content"
            style={{
              height: '100%',
              width: '100%',
              backgroundImage: isDarkMode
                ? `url(${darkBackgroundImage})`
                : netzwerkBackground,
              backgroundSize: isDarkMode ? '101% 101%' : 'auto 115%',
              backgroundRepeat: 'no-repeat',
              ...(isDarkMode
                ? { backgroundPositionX: '9%' }
                : { backgroundPosition: 'right center' }),
            }}
          >
            {<InitialPage widgets={widgetsTree}></InitialPage>}
          </MainContent>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>Cancel</Button>
        </DialogActions>
      </Box>
    </>
  );
};

export default PreviewUserGroupContent;
